import { defineComponent } from 'vue';
import { mapState, mapGetters, useStore } from 'vuex';
import FilePopItem from '@remote/components/FilePopItem.vue';
import Spin from '@remote/components/Spin.vue';
import { disableCloseOnBack, enableCloseOnBack } from '@remote/router';
// import router from '@remote/router'
export default defineComponent({
  components: {
    FilePopItem,
    Spin
  },
  setup() {
    return {
      store: useStore()
    };
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapState(['showFilePop', 'filePopTaskID', 'files', 'all', 'parentIds']),
    ...mapGetters(['curList']),
    fileList() {
      const list = this.files.map(id => this.all[id]);
      return list;
    }
  },
  watch: {
    showFilePop(val) {
      // 这里是为了达到点击返回（后退）键，能够关闭弹窗
      const closeAndRemovePopStateListener = () => {
        window.removeEventListener('popstate', closeAndRemovePopStateListener);
        enableCloseOnBack();
        this.close();
      };
      if (val) {
        history.pushState({}, '', location.pathname);
        disableCloseOnBack();
        window.addEventListener('popstate', closeAndRemovePopStateListener);
      }
    }
  },
  mounted() {},
  methods: {
    close() {
      this.store.commit('update', {
        showFilePop: false,
        parentIds: [],
        filePopTaskID: ''
      });
    },
    async loadFunction(file) {
      this.isLoading = true;
      try {
        await this.store.dispatch('getFiles', {
          parent_id: file.id,
          name: file.name
        });
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async goBack() {
      const parent_id = this.parentIds[this.parentIds.length - 2].id;
      await this.store.dispatch('getFiles', {
        parent_id,
        isBack: true
      });
    },
    async backHome() {
      const parent_id = this.parentIds[0].id;
      await this.store.dispatch('getFiles', {
        parent_id,
        isBackHome: true
      });
    }
  }
});